var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScroll1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#773DD3",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.735 36.5106C42.3304 35.9918 41.6104 35.9208 41.1258 36.354L36.143 40.7998V26.2804C36.143 25.6049 35.631 25.0566 35.0002 25.0566C34.3693 25.0566 33.8573 25.6049 33.8573 26.2804V40.7998L28.8745 36.354C28.3888 35.9208 27.6688 35.9918 27.2654 36.5106C26.8608 37.0295 26.926 37.8017 27.4117 38.2336L34.2688 44.3522C34.3225 44.4012 34.3865 44.4244 34.4459 44.4611C34.4928 44.4905 34.5339 44.5247 34.5853 44.5468C34.719 44.6031 34.8585 44.6361 35.0002 44.6361C35.1419 44.6361 35.2813 44.6031 35.415 44.5468C35.4665 44.5247 35.5076 44.4905 35.5545 44.4611C35.6139 44.4244 35.6779 44.4012 35.7316 44.3522L42.5887 38.2336C43.0732 37.8017 43.1395 37.0295 42.735 36.5106Z",
    fill: "#773DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll1);
export default __webpack_public_path__ + "static/media/scroll1.101314ed04e0c1b61e43ae14523205b1.svg";
export { ForwardRef as ReactComponent };